import { defineMessages, enPlural } from '@/i18n'

export const messages = defineMessages({
  ru: {
    difficultyEasy: 'Лёгкая',
    difficultyMedium: 'Средняя',
    difficultyHard: 'Сложная',
    difficulty: 'Сложность',
    all: 'Все',
    active: 'Активно:',
    resetAll: 'Сбросить всё',
    removeFilter: (label: string) => `Убрать фильтр ${label}`,
    allLanguages: 'Все языки',
    allCategories: 'Все категории',
    sortPopular: 'По рейтингу',
    sortUpdated: 'По дате изменения',
    sortCompletions: 'По прохождениям',
    categoriesCount: (n: number) => `Категорий: ${n}`,
  },
  en: {
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',
    difficulty: 'Difficulty',
    all: 'All',
    active: 'Active:',
    resetAll: 'Reset all',
    removeFilter: (label: string) => `Remove the “${label}” filter`,
    allLanguages: 'All languages',
    allCategories: 'All categories',
    sortPopular: 'Top rated',
    sortUpdated: 'Recently updated',
    sortCompletions: 'By completions',
    categoriesCount: (n: number) => `${n} ${enPlural(n, 'category', 'categories')}`,
  },
})
